import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { recurringApi, ApiError } from '../services/api';
import type { CreateRecurringRequest } from '@cp-parkingslots/shared';

export function useRecurringRules() {
  return useQuery({
    queryKey: ['recurring'],
    queryFn: () => recurringApi.getRecurringRules(),
  });
}

export function useCreateRecurringRule() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateRecurringRequest) =>
      recurringApi.createRecurringRule(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['recurring'] });
      queryClient.invalidateQueries({ queryKey: ['reservations'] });
    },
    onError: (error: ApiError) => {
      console.error('Failed to create recurring rule:', error);
    },
  });
}

export function useDeleteRecurringRule() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => recurringApi.deleteRecurringRule(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['recurring'] });
      queryClient.invalidateQueries({ queryKey: ['reservations'] });
    },
    onError: (error: ApiError) => {
      console.error('Failed to delete recurring rule:', error);
    },
  });
}
